// frontend/src/menuConfig.js
// Helper function to filter submenus and remove empty parent menus
const processMenu = (menu, hasPermission) => {
  return menu.map(item => {
    if (item.submenu) {
      // Recursively process submenus
      const filteredSubmenu = processMenu(item.submenu, hasPermission);
      // If the submenu is not empty after filtering, return the item with the filtered submenu
      if (filteredSubmenu.length > 0) {
        return { ...item, submenu: filteredSubmenu };
      }
      // If the submenu is empty, return null to be filtered out
      return null;
    }
    // If the item has a permission check and fails, return null
    if (item.permission && !hasPermission(item.permission.module, item.permission.action)) {
      return null;
    }
    // Otherwise, return the item
    return item;
  }).filter(Boolean); // Filter out null items
};

// The static, complete menu configuration. Export this for appConfig.
export const baseMenuConfig = [
  {
    title: 'Dashboard',
    permission: { module: 'DASHBOARD', action: 'can_view' }, // <-- ADDED PERMISSION CHECK
    link: '/html/Dashboard.html'
  },
  {
    title: 'Masters',
    permission: { module: 'MASTERS', action: 'can_view' }, // <-- ADDED PERMISSION CHECK
    submenu: [
      { title: 'Customers', link: '/react/CustomerList', permission: { module: 'CUSTOMERS', action: 'can_view' } },
      { title: 'Suppliers', link: '/react/SupplierList', permission: { module: 'SUPPLIERS', action: 'can_view' } },
      { title: 'Shipping Lines', link: '/react/ShippingLineList', permission: { module: 'SHIPPING LINES', action: 'can_view' } },
      { title: 'Vessel Voyages', link: '/react/VesselVoyageList', permission: { module: 'VESSEL VOYAGES', action: 'can_view' } },
      { title: 'Vendors', link: '/react/VendorList', permission: { module: 'VENDORS', action: 'can_view' } },
      { title: 'Transporters', link: '/react/TransporterList', permission: { module: 'TRANSPORTERS', action: 'can_view' } }
    ]
  },
  {
    title: 'Documentation',
    // permission: { module: 'DOCUMENTATION', action: 'can_view' }, // <-- ADDED PERMISSION CHECK
    submenu: [
      { title: 'Jobs', link: '/react/JobList', permission: { module: 'JOBS', action: 'can_view' } },      
      { title: 'Incomplete Jobs', link: '/react/IncompleteJobsReport', permission: { module: 'INCOMPLETE JOBS', action: 'can_view' } },
      { title: 'P-PAD Report', link: '/react/PPADReport', permission: { module: 'P-PAD REPORT', action: 'can_view' } },
      { title: 'Accepted Assessments', link: '/react/AcceptedReport', permission: { module: 'ACCEPTED ASSESSMENTS', action: 'can_view' } },
      { title: 'Manifest Report', link: '/react/ManifestReport', permission: { module: 'MANIFEST REPORT', action: 'can_view' } },
      { title: 'Border Report', link: '/react/BorderReport', permission: { module: 'BORDER REPORT', action: 'can_view' } },
      { title: 'Ex Bond Report', link: '/react/ExBondReport', permission: { module: 'EX BOND REPORTS', action: 'can_view' } },
      { title: 'Client Reports', link: '/react/ClientReports', permission: { module: 'CLIENT REPORTS', action: 'can_view' } },
      { title: 'Customer Portal', link: '/react/CustomerPortal', permission: { module: 'USER MANAGEMENT', action: 'can_view' } },
      { title: 'Search Item', link: '/react/SearchItem', permission: { module: 'SEARCH ITEM', action: 'can_view' } },
      { title: 'Payables', link: '/react/DocPayables', permission: { module: 'DOC_PAYABLES', action: 'can_view' } },
      { title: 'Lists Configuration', link: '/react/ListsConfiguration', permission: { module: 'LISTS CONFIGURATION', action: 'can_view' } }
    ]
  },
  {
    title: 'Shipping Line',
    permission: { module: 'SHIPPING LINE', action: 'can_view' }, // <-- ADDED PERMISSION CHECK
    submenu: [
      { title: 'Shipping Tasks Report', link: '/react/ShippingTasksReport', permission: { module: 'SHIPPING TASKS REPORT', action: 'can_view' } },
      { title: 'Shipping Reports', link: '/react/ShippingReport', permission: { module: 'SHIPPING REPORTS', action: 'can_view' } },
      { title: 'EIR Reports', link: '/react/EIRReport', permission: { module: 'EIR REPORTS', action: 'can_view' } },
      { title: 'Drop Off Locations', link: '/react/DropOffLocations', permission: { module: 'DROP OFF LOCATIONS', action: 'can_view' } },
      { title: 'Payables', link: '/react/ShippingLinePayables', permission: { module: 'SHIPPING LINE PAYABLES', action: 'can_view' } }     
    ]
  },
  {
    title: 'Permits',
    permission: { module: 'PERMITS MENU', action: 'can_view' }, // <-- ADDED UNIQUE PARENT PERMISSION CHECK
    submenu: [
        // Note: The 'Permits' link under Admin Panel is the main one. This could be a duplicate or for a different purpose.
        // For now, we assume it points to the same component.
        { title: 'Permit Reports', link: '/react/PermitReport', permission: { module: 'PERMIT REPORTS', action: 'can_view' } },
        { title: 'TMDA Applications', link: '/react/TMDAApplications', permission: { module: 'TMDA APPLICATIONS', action: 'can_view' } },
        { title: 'Permits List', link: '/react/Permits', permission: { module: 'PERMITS', action: 'can_view' } },
        { title: 'Payables', link: '/react/PermitPayables', permission: { module: 'PERMIT_PAYABLES', action: 'can_view' } },
        { title: 'Permit Funds', link: '/react/PermitFunds', permission: { module: 'PERMIT FUNDS', action: 'can_view' } }
        
    ]
  },
  {
    title: 'Port',
    //permission: { module: 'PORT', action: 'can_view' }, // <-- ADDED PERMISSION CHECK
    submenu: [
      // FIX: Renamed module to decouple from Documentation's Manifest Report
      { title: 'Manifest Report', link: '/react/ManifestReport', permission: { module: 'PORT MANIFEST REPORT', action: 'can_view' } },
      { title: 'Port Reports', link: '/react/PortReport', permission: { module: 'PORT REPORTS', action: 'can_view' } },
      { title: 'Airport Report', link: '/react/AirportReport', permission: { module: 'AIRPORT REPORTS', action: 'can_view' } },
      { title: 'Border Report', link: '/react/BorderReport', permission: { module: 'PORT BORDER REPORT', action: 'can_view' } },
      { title: 'ZNZ Report', link: '/react/ZNZReport', permission: { module: 'ZNZ REPORT', action: 'can_view' } },
      { title: 'Port Configurations', link: '/react/PortConfiguration', permission: { module: 'PORT CONFIGURATIONS', action: 'can_view' } },
      { title: 'Payables', link: '/react/PortPayables', permission: { module: 'PORT_PAYABLES', action: 'can_view' } },
      { title: 'Transporter Portal', link: '/react/TransporterPortal', permission: { module: 'TRANSPORTER USER MANAGEMENT', action: 'can_view' } }
    ]
  },
  {
    title: 'Accounts',
    permission: { module: 'ACCOUNTS', action: 'can_view' },
    submenu: [
      { title: 'Bank Accounts', link: '/react/BankAccounts', permission: { module: 'BANK ACCOUNTS', action: 'can_view' } },
      { title: 'Payables', link: '/react/Payables', permission: { module: 'PAYABLES', action: 'can_view' } },
      { title: 'Payables Approvals', link: '/react/PayablesApprovals', permission: { module: 'PAYABLES APPROVALS', action: 'can_view' } },
      { title: 'Cash/Office Approvals', link: '/react/CashOfficeApprovals', permission: { module: 'CASH OFFICE APPROVALS', action: 'can_view' } },
      { title: 'Receivables', link: '/react/Receivables', permission: { module: 'RECEIVABLES', action: 'can_view' } },
      { title: 'Invoicing', link: '/react/Invoicing', permission: { module: 'INVOICING', action: 'can_view' } },
      { title: 'Client Statements', link: '/react/ClientStatements', permission: { module: 'CLIENT STATEMENTS', action: 'can_view' } },
      { title: 'Transporter Invoicing', link: '/react/TransporterInvoicingAdmin', permission: { module: 'TRANSPORTER INVOICING', action: 'can_view' } },
      { title: 'Fund Request', link: '/react/FundRequest', permission: { module: 'FUND REQUEST', action: 'can_view' } },
      { title: 'Settings', link: '/react/AccountsSettings', permission: { module: 'ACCOUNTS SETTINGS', action: 'can_view' } }
    ]
  },
  {
    title: 'HR',
    permission: { module: 'HR', action: 'can_view' }, // <-- NEW MODULE
    submenu: [
      { title: 'Staffs', link: '/react/Staffs', permission: { module: 'STAFFS', action: 'can_view' } }, // <-- MOVED HERE
      { title: 'Payroll', link: '/react/Payroll', permission: { module: 'PAYROLL', action: 'can_view' } },
      { title: 'Attendance', link: '/react/Attendance', permission: { module: 'ATTENDANCE', action: 'can_view' } },
      { title: 'Loans', link: '/react/Loans', permission: { module: 'LOANS', action: 'can_view' } },
      { title: 'Advances', link: '/react/Advances', permission: { module: 'ADVANCES', action: 'can_view' } }
    ]
  },
  {
    title: 'Reports',
    permission: { module: 'REPORTS', action: 'can_view' }, // <-- MOVED FROM ADMIN PANEL
    submenu: [
      // FIX: Renamed all Admin Reports to be unique
      { title: 'Incomplete Jobs', link: '/react/IncompleteJobsReport', permission: { module: 'ADMIN INCOMPLETE JOBS', action: 'can_view' } },
      { title: 'P-PAD Report', link: '/react/PPADReport', permission: { module: 'ADMIN P-PAD REPORT', action: 'can_view' } },
      { title: 'Accepted Assessments', link: '/react/AcceptedReport', permission: { module: 'ADMIN ACCEPTED ASSESSMENTS', action: 'can_view' } },
      { title: 'Shipping Tasks Report', link: '/react/ShippingTasksReport', permission: { module: 'ADMIN SHIPPING TASKS REPORT', action: 'can_view' } },
      { title: 'Shipping Reports', link: '/react/ShippingReport', permission: { module: 'ADMIN SHIPPING REPORTS', action: 'can_view' } },
      { title: 'EIR Reports', link: '/react/EIRReport', permission: { module: 'ADMIN EIR REPORTS', action: 'can_view' } },
      { title: 'Permit Reports', link: '/react/PermitReport', permission: { module: 'ADMIN PERMIT REPORTS', action: 'can_view' } },
      { title: 'Port Reports', link: '/react/PortReport', permission: { module: 'ADMIN PORT REPORTS', action: 'can_view' } },
      { title: 'Manifest Report', link: '/react/ManifestReport', permission: { module: 'ADMIN MANIFEST REPORT', action: 'can_view' } },      
      { title: 'Airport Report', link: '/react/AirportReport', permission: { module: 'ADMIN AIRPORT REPORTS', action: 'can_view' } },
      { title: 'Border Report', link: '/react/BorderReport', permission: { module: 'ADMIN BORDER REPORTS', action: 'can_view' } },
      { title: 'ZNZ Report', link: '/react/ZNZReport', permission: { module: 'ADMIN ZNZ REPORT', action: 'can_view' } },
      { title: 'Ex Bond Report', link: '/react/ExBondReport', permission: { module: 'ADMIN EX BOND REPORTS', action: 'can_view' } },
      { title: 'Client Reports', link: '/react/ClientReports', permission: { module: 'ADMIN CLIENT REPORTS', action: 'can_view' } }
    ]
  },
  {
    title: 'Admin Panel',
    permission: { module: 'ADMIN PANEL', action: 'can_view' }, // <-- ADDED PERMISSION CHECK
    submenu: [
      { title: 'Email Configurations', link: '/react/EmailConfigurations', permission: { module: 'EMAIL CONFIGURATIONS', action: 'can_view' } },
      { title: 'Departments', link: '/react/Departments', permission: { module: 'DEPARTMENTS', action: 'can_view' } },
      // { title: 'Staffs', link: '/react/Staffs', permission: { module: 'STAFFS', action: 'can_view' } }, // <-- REMOVED FROM HERE
      { title: 'User Management', link: '/react/UserManagement', permission: { module: 'ADMIN USER MANAGEMENT', action: 'can_view' } },
      // FIX: Renamed Admin Permits to decouple from the main Permits menu
      { title: 'Permit Management', link: '/react/Permits', permission: { module: 'ADMIN PERMITS', action: 'can_view' } },
      { title: 'Banks', link: '/react/Banks', permission: { module: 'BANKS', action: 'can_view' } },
      { title: 'Payable Charges', link: '/react/PayableChargesList', permission: { module: 'PAYABLE CHARGES', action: 'can_view' } },
      { title: 'Lists Configuration', link: '/react/ListsConfiguration', permission: { module: 'ADMIN PANEL LISTS CONFIGURATION', action: 'can_view' } },
      { title: 'User Logs', link: '/react/UserLogs', permission: { module: 'USER LOGS', action: 'can_view' } },
      { title: 'Notifications', link: '/react/Notifications', permission: { module: 'NOTIFICATIONS', action: 'can_view' } },
      { title: 'Company Details', link: '/react/CompanyDetails', permission: { module: 'COMPANY DETAILS', action: 'can_view' } }
    ]
  },
  {
    title: 'Tools',
    submenu: [
      { title: 'Missing Documents', link: '/react/MissingDocuments', permission: { module: 'MISSING DOCUMENTS', action: 'can_view' } },
      { title: 'Quick Reference', link: '/react/QuickReference', permission: { module: 'QUICK REFERENCE', action: 'can_view' } }
    ]
  }
];

// The function that filters the menu based on permissions.
export const getMenuConfig = (hasPermission) => {
  
  const filterMenu = (items) => {
    return items.reduce((acc, item) => {
      // 1. STRICT PARENT CHECK:
      // Check if the current item has a permission requirement.
      // If the user fails this check, discard the item IMMEDIATELY, 
      // regardless of whether its children are visible.
      if (item.permission) {
        const { module, action } = item.permission;
        if (!hasPermission(module, action)) {
          return acc; // Skip this item
        }
      }

      // 2. PROCESS CHILDREN:
      // If the item passes the permission check (or has none), process its submenu.
      if (item.submenu) {
        const filteredSubmenu = filterMenu(item.submenu);
        
        // If the submenu becomes empty after filtering, and it was a dropdown,
        // we generally want to hide the parent too.
        if (filteredSubmenu.length > 0) {
          acc.push({ ...item, submenu: filteredSubmenu });
        }
      } else {
        // It's a leaf link (no submenu), and it passed the permission check above.
        acc.push(item);
      }

      return acc;
    }, []);
  };

  return filterMenu(baseMenuConfig);
};
